import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';

let translateServiceInstance: TranslateService;

export const errorInterceptorFn: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const router = inject(Router);
  const getTranslateService = (): TranslateService | null => {
    if (!translateServiceInstance) {
      try {
        translateServiceInstance = injector.get(TranslateService);
      } catch (e) {
        console.error(
          'ErrorInterceptor: Failed to get TranslateService instance. Translations might not work for error messages.',
          e,
        );
        return null;
      }
    }
    return translateServiceInstance;
  };

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const translate = getTranslateService();
      let errorMessage = translate?.instant('error-default-toaster-unknown');
      if (error.error instanceof ErrorEvent) {
        errorMessage = translate?.instant('error-default-toaster-client-side', {
          errorMessage: error.error.message,
        });
      } else {
        errorMessage = translate?.instant('error-default-toaster-server-side', {
          errorCode: error.status,
          errorMessage: error.message,
        });
        const skipAuthHandling = false;

        switch (error.status) {
          case 401: // Unauthorized
            if (!skipAuthHandling) {
              console.error('Error Interceptor: Unauthorized', error);
              localStorage.removeItem('gateway_auth_token');
              router.navigate(['/login']);
            }
            break;
          case 403: // Forbidden - authenticated but not authorized
            console.error('Error Interceptor: Forbidden - insufficient permissions', error);
            break;
          case 404: //Not Found
            console.warn('Error Interceptor: Not Found', error);
            break;
          case 500: // Internal Server Error
            console.error('Error Interceptor: Server Error', error);
            break;
          default: // Other errors
            console.error('Error Interceptor: Other HTTP Error', error);
        }
      }
      // It's VERY important to re-throw the error so that local catchError blocks in services/components can also handle it if needed.
      return throwError(() => error);
    }),
  );
};
